import classNames from 'classnames';
import { forwardRef } from 'react';
import { FieldRenderProps } from 'react-final-form';
import './PlainSelectField.styles.scss';

type Option = {
  value: string;
  label: string;
};

type SelectFieldProps = FieldRenderProps<string, HTMLElement> & {
  label?: string;
  options: Option[];
  className?: string;
  placeholder?: string;
  onChange?: (value: string) => void; // 👈 custom handler
};

export const PlainSelectField = forwardRef<HTMLSelectElement, SelectFieldProps>(
  (
    {
      input,
      meta,
      label,
      options,
      className,
      placeholder = 'Select an option',
      onChange, // 👈 destructure it
      ...rest
    },
    ref,
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      input.onChange(e); // Final Form’s internal change handler
      onChange?.(e.target.value); // 👈 Call custom handler if provided
    };

    return (
      <div className={classNames('select-field', className)}>
        {label && <label>{label}</label>}

        <select
          {...input}
          {...rest}
          ref={ref}
          onChange={handleChange} // 👈 our combined handler
          className="ncoded-input"
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        {meta.touched && meta.error && (
          <small className="error-text">{meta.error}</small>
        )}
      </div>
    );
  },
);

export default PlainSelectField;
